/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope). */

.bar {
  position: sticky;
  bottom: 0;
  z-index: 1;
  padding: var(--spacing-4) var(--spacing-6);
  background: var(--color-background-surface);
  border-top: 1px solid var(--color-border);
}

/* Constrains the actions to the same 1200px column as ContentContainer's
   .container, so the footer's contents line up with the page content above
   it, while .bar itself stays full-width for the sticky background/border. */
.inner {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--spacing-4);
  max-width: 1200px;
  margin: 0 auto;
}

.error {
  margin: 0 auto 0 0;
  font-size: var(--font-size-sm);
  color: var(--color-error);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
}
